import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './ResponsiveFrame.module.scss';
const ResponsiveFrame = forwardRef(({ children, className, height, width }, elementRef) => {
    return (_jsx("div", { className: classNames(styles.responsiveFrame, className), style: width && height ? { paddingTop: `calc(${height} / ${width} * 100%)` } : {}, ref: elementRef, children: children }));
});
ResponsiveFrame.displayName = ResponsiveFrame.name;
export { ResponsiveFrame };
